import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RadioConfig } from '../../../model';
import { FormControl } from '@angular/forms';

/**
 * * Componente de input radio para os formulários.
 */
@Component({
  selector: 'ui-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss']
})
export class RadioInputComponent implements OnInit {

  /**
   * * Título do Input.
   */
  @Input() title!: string;

  /**
   * * FormControl
   */
  @Input() formControl!: FormControl;

  /**
   * * Lista com os radios a serem exibidos.
   */
  @Input() options: RadioConfig[] = [];

  /**
   * * Evento disparado ao selecionar um Radio.
   */
  @Output() onselect: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onSelect(option: RadioConfig): void {
    this.options.forEach(opt => {
      opt.selected = opt.id === option.id;
    });

    this.onselect.emit(option.id);
  }


}
